/**
 * Redondeos del motor. Existen para que 3 * 33 / 100 sea 0,99 y no
 * 0,9899999999999999: en una app de nutricion esos arrastres acaban saliendo
 * en pantalla.
 */

export function round(value: number, decimals: number): number {
  const factor = 10 ** decimals;
  return Math.round(value * factor) / factor;
}

/** Para totales y valores intermedios: mata el ruido binario sin perder nada real. */
export function round6(value: number): number {
  return round(value, 6);
}

export function round2(value: number): number {
  return round(value, 2);
}

/** Acota un valor a un rango cerrado. */
export function clamp(value: number, min: number, max: number): number {
  return Math.min(Math.max(value, min), max);
}

/**
 * Factor de decaimiento por dia para una media ponderada exponencial dada su
 * semivida: tras `halfLifeDays` dias, un dato pesa la mitad.
 */
export function decayPerDay(halfLifeDays: number): number {
  return Math.pow(0.5, 1 / halfLifeDays);
}
